module.exports = __webpack_public_path__ + "media/stylesheets/images/focus-14461b40c65baa46dec124986da33211.png";